import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=21b37154&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=21b37154&prod&lang=scss&scoped=true"
import style1 from "./Feedback.vue?vue&type=style&index=1&id=21b37154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b37154",
  null
  
)

export default component.exports